export default {
    to: "/dashboard/services",
    order: 3,
    icon: "mdi-layers-outline",
    title: "Services",
    disabled: false,
    value: 0,
    sublinks: [],
}
